import React from 'react';
import { Container } from '@mui/material';
import ContactForm from '../components/ContactForm';

function Contact() {
  return (
    <Container disableGutters>
      <ContactForm />
    </Container>
  );
}

export default Contact;